export function surveyElementsCoreUtils(): string {
  return 'survey-elements-core-utils';
}
